module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vfcleg4-f705f2bdb0495a6b57092d01a37b47a2.jpg";